import { __assign, __extends } from "tslib";
import React from 'react';
import { View, StatusBar, ScrollView, SectionList, RefreshControl, SafeAreaView } from 'react-native';
// Custom
import { platformUtils } from '../utils';
import c from '../styles/_colors.js';
import ErrorCard from '../ErrorCard';
import ActivityIndicator from '../PnmacActivityIndicator/ActivityIndicator.js';
var ScreenContainer = function (props) {
  return /*#__PURE__*/React.createElement(SafeAreaView, {
    style: [s.container, props.style]
  }, /*#__PURE__*/React.createElement(StatusBar, {
    barStyle: "light-content",
    animated: true
  }), props.loading && !props.refreshing ? (/*#__PURE__*/React.createElement(View, {
    style: s.centerCenter
  }, /*#__PURE__*/React.createElement(View, {
    style: {
      display: 'flex',
      flexDirection: 'row',
      justifyContent: 'center'
    }
  }, /*#__PURE__*/React.createElement(ActivityIndicator, {
    size: "small",
    color: c.gray
  })))) : props.error && !props.hasInfo ? /*#__PURE__*/React.createElement(View, {
    style: s.centerCenter
  }, /*#__PURE__*/React.createElement(ErrorCard, __assign({}, props))) : props.hasOwnProperty('hasInfo') && !props.hasInfo ? /*#__PURE__*/React.createElement(View, {
    style: s.centerCenter
  }, /*#__PURE__*/React.createElement(ErrorCard, __assign({
    delayReporting: true,
    sentryMessage: "Has Info Problem"
  }, props))) : props.children);
};
var ScrollContainer = function (props) {
  return /*#__PURE__*/React.createElement(ScrollView, __assign({}, props.onRefresh ? {
    refreshControl: /*#__PURE__*/React.createElement(RefreshControl, {
      refreshing: props.refreshing,
      onRefresh: props.onRefresh,
      tintColor: props.refreshColor || c.white,
      colors: [platformUtils.ifAndroid(c.blue, c.white)]
    })
  } : {}, props, {
    style: [s.scrollContainer, props.style],
    contentContainerStyle: [s.scrollView(true), props.contentContainerStyle]
  }), /*#__PURE__*/React.createElement(View, null, props.error && /*#__PURE__*/React.createElement(View, {
    style: s.topCenter(props)
  }, /*#__PURE__*/React.createElement(ErrorCard, __assign({}, props))), props.children));
};
var SectionListContainer = /** @class */function (_super) {
  __extends(SectionListContainer, _super);
  function SectionListContainer() {
    return _super !== null && _super.apply(this, arguments) || this;
  }
  SectionListContainer.prototype.render = function () {
    var props = this.props;
    return /*#__PURE__*/React.createElement(SectionList, __assign({}, props.onRefresh ? {
      refreshControl: /*#__PURE__*/React.createElement(RefreshControl, {
        refreshing: props.refreshing,
        onRefresh: props.onRefresh,
        tintColor: props.refreshColor || c.white,
        colors: [platformUtils.ifAndroid(c.blue, c.white)]
      })
    } : {}, props, {
      style: [s.scrollContainer, props.style],
      contentContainerStyle: [s.scrollView(false), props.contentContainerStyle]
    }));
  };
  return SectionListContainer;
}(React.PureComponent);
ScreenContainer.ScrollView = ScrollContainer;
ScreenContainer.SectionList = SectionListContainer;
export default ScreenContainer;
var s = {
  container: {
    flex: 1
  },
  centerCenter: {
    justifyContent: 'center',
    flex: 1
  },
  topCenter: function (props) {
    return {
      paddingTop: 15,
      paddingBottom: 7,
      backgroundColor: (props.style || {}).backgroundColor || s.scrollContainer.backgroundColor
    };
  },
  scrollView: function (topPadding) {
    return {
      paddingTop: topPadding ? 10 : 0
    };
  }
};